import { Grid, TableCell, TableRow } from "@material-ui/core";
import { MasterButton } from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { formatNumber } from "App/utils/helpers";
import { FreezeTableClient } from "components/organism";
import React from "react";
import { headCellsHasil } from "./helpers";
import Modal from "App/Component/ui/Modal/Modal";
import DataCount from "./DataCount";

function ModalCheckStok({ setShowModal, dataError }) {
  return (
    <>
      <Modal
        title={`Tidak Dapat Melanjutkan Penghapusan !`}
        show={setShowModal}
        width="90%"
      >
        <Grid container spacing={3}>
          <Grid item sm={12}>
            <DataCount dataError={dataError} />
          </Grid>
          <Grid item sm={12}>
            <TableHasil title="Jumlah QTY Minus" rows={dataError.hasil_minus} />
          </Grid>
          <Grid item md={12}>
            <TableHasil title="Jumlah QTY Infalid" rows={dataError.qty_inventory_invalid} />
          </Grid>
          <Grid item md={12}>
            <TableHasil title="Jumlah Item Inventory Terhapus" rows={dataError.inventory_terhapus} />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mr-1 mt-1"}
            color={"green"}
            size="lg"
            onClick={() => setShowModal()}
            name={"Tutup"}
          />
        </Grid>
      </Modal>
    </>
  );
}

const TableHasil = ({ rows, title }) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "",
    orderByRow: ["nama_barang"],
  });
  return (
    <>
      <Grid item sm={12}>
        <FreezeTableClient
          isFreeze={false}
          trTopChild="61px"
          title={title}
          setQ={setQ}
          maxHeight="200px"
          withAddButton={false}
          withExportButton={false}
          order={order}
          orderBy={orderBy}
          handleRequestSort={handleRequestSort}
          length={length}
          rows={rows}
          headCells={headCellsHasil}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          headCellsLength={18}
          setRowsPerPage={setRowsPerPage}
        >
          {stableSort(data, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
              return (
                <TableRow hover tabIndex={-1} key={index}>
                  <TableCell scope="row" padding="none" align="center">
                    {index + 1}
                  </TableCell>
                  <TableCell align="left">{row.id_inventory}</TableCell>
                  <TableCell align="left">{row.barang_id}</TableCell>
                  <TableCell align="left">{row.nama_barang}</TableCell>
                  <TableCell align="right">
                    {formatNumber(row.kebutuhan_stock)}
                  </TableCell>
                </TableRow>
              );
            })}
        </FreezeTableClient>
      </Grid>
    </>
  );
};

export default ModalCheckStok;
